// Shared palette of named color tokens (each maps to a `--{name}-100`/
// `--{name}-700` pair in colors.scss) used to hash a string to a consistent
// color across renders — a given item always gets the same color, not one
// tied to its position in a list. Used wherever there's no real icon/photo
// for something (a person's initials, a domain's monogram, a department
// avatar) and a stable, varied set of colors is needed instead.
export const HASHED_COLOR_PALETTE = [
  'blue',
  'success',
  'purple',
  'orange',
  'rose',
];

function hashString(str = '') {
  return str.split('').reduce((hash, char) => hash + char.charCodeAt(0), 0);
}

export function getHashedColor(label, palette = HASHED_COLOR_PALETTE) {
  const name = (label || '?').trim();
  return palette[hashString(name) % palette.length];
}
